import { trapFocus } from "../utils/accessibility"

$(function () {
  "use strict"
  const sidebarContent = $("#sidebar-content")

  function closeSidebar() {
    $("#nav-sidebar").removeClass("open")
    $("body").removeClass("apply-scroll-lock")
    $("#open-sidebar").focus().attr("aria-expanded", false)
  }

  $("#open-sidebar").on("click", () => {
    $("#nav-sidebar").addClass("open")
    $("#open-sidebar").attr("aria-expanded", true)
    $("body").addClass("apply-scroll-lock")
  })

  $("#close-sidebar").on("click", closeSidebar)
  $("#nav-sidebar").on("click", closeSidebar)
  $(".hamburger-menu-close-button").on("click", closeSidebar)

  $("#sidebar-content").on("click", (e) => {
    e.stopPropagation()
  })

  sidebarContent.on("keydown", (e) => {
    trapFocus(e, sidebarContent)
  })
})
